import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import AdminSidebar from './navigation/AdminSidebar';
import AdminHeader from './navigation/AdminHeader';
import { STORAGE_KEYS } from '../constants';

/**
 * Admin Layout Component
 * Main layout wrapper with sidebar and header
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Page content
 */
const AdminLayout = ({ children }) => {
  // Load sidebar state from localStorage
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    const saved = localStorage.getItem(STORAGE_KEYS.SIDEBAR_COLLAPSED);
    return saved === 'true';
  });

  // Save sidebar state to localStorage
  useEffect(() => {
    localStorage.setItem(STORAGE_KEYS.SIDEBAR_COLLAPSED, String(sidebarCollapsed));
  }, [sidebarCollapsed]);

  const toggleSidebar = () => {
    setSidebarCollapsed(prev => !prev);
  };

  return (
    <div className="admin-layout">
      <AdminSidebar 
        collapsed={sidebarCollapsed} 
        onToggle={toggleSidebar}
      />
      <div className={`admin-main ${sidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <AdminHeader onToggleSidebar={toggleSidebar} />
        <main className="admin-content">
          {children}
        </main>
      </div>
    </div>
  );
};

AdminLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default AdminLayout;
